import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Modal from './Modal';

function Portfolio() {
    const [nextItems, setNextItems] = useState(6);
    const [portfolio, setPortfolio] = useState([]);
    const [selectedTab, setSelectedTab] = useState('all');
    const [showModal, setShowModal] = useState(false);
    const [activeId, setActiveId] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get('https://por2.onrender.com/api/projects?populate=*');
                setPortfolio(response.data.data); // Set projects directly from response.data.data
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []); // Fetch data when the component mounts

    const loadMoreHandler = () => {
        setNextItems(prev => prev + 3);
    };
    const showModalHandler = (id) => {
        setShowModal(true);
        setActiveId(id);
    };
    const domain = "https://por2.onrender.com";
    return (
        <section id="portfolio">
            <div className='container'>
                <div className='flex items-center justify-between flex-wrap'>
                    <div className='mb-7 sm:mb-0'>
                        <h3 className='text-sky-600 text-[2rem] font-[700]'>
                            My recent projects
                        </h3>
                    </div>

                </div>
                <div className='flex items-center gap-4 flex-wrap mt-12'>
                    {portfolio.slice(0, nextItems).map((project, index) => (
                        <div className='group max-w-full  sm:w-[48.5%]  md:w-[31.8%]  lg:w-[32.2%]  relative z-[1]' key={index} >
                            <figure>
                                <img className='rounded-[8px]' src={project.attributes.image.data.attributes.url} alt={project.attributes.title} />
                            </figure>
                            <div className='w-full h-full bg-sky-500 bg-opacity-40 absolute top-0 left-0 z-[5] hidden group-hover:block'>
                                <div className='w-full h-full flex items-center justify-center'>
                                    <button onClick={() => showModalHandler(project.id)} className='text-white bg-gray-700 py-2 px-4 rounded-[8px] font-[500] ease-in duration-200'>See Details</button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className='text-center mt-6'>
                    {nextItems < portfolio.length && (
                        <button className='text-white bg-gray-700 py-2 px-4 rounded-[8px] font-[500] ease-in duration-200' onClick={loadMoreHandler}>Load More</button>
                    )}
                </div>
            </div>
            {showModal && <Modal setShowModal={setShowModal} activeId={activeId} />}
        </section>
    );
}

export default Portfolio;
